const btnFilterManagementEquip = {
  label: 'filters',
  Typography: 'No results found'
};

export default btnFilterManagementEquip;
